module.exports = __webpack_public_path__ + "static/media/no-NO.47675af9.md";